import { useSelect } from "@wordpress/data";
import { useState, useEffect } from "@wordpress/element";

export default function box({ attributes, docSections, articlesNumber }) {
    const { col, docs_layout, readMoreText, orderBy, child_docs_order, show_topic, isFeaturedImage } = attributes;

    // Determine layout type based on attributes
    const layoutType = docs_layout === "grid" ? `ezd-grid ezd-column-${col}` : `ezd-masonry-wrap ezd-masonry-col-${col}`;

    // Fetch all doc items for each section in a single call
    const allDocItems = useSelect((select) => {
        const parentIds = docSections?.map((section) => section.id) || [];
        return parentIds.map((parentId) => ({
            parentId,
            items: select("core").getEntityRecords("postType", "docs", {
                per_page: articlesNumber,
                order: child_docs_order,
                orderby: orderBy,
                parent: parentId,
                status: ['publish', 'private']
            }),
        }));
    }, [articlesNumber, docSections, child_docs_order, orderBy]);


    // Count child items for each parent
    const childCounts = allDocItems.reduce((acc, { parentId, items }) => {
        acc[parentId] = items ? items.length : 0;
        return acc;
    }, {});

  
    // State for all featured media images
    const [images, setImages] = useState({});

    useEffect(() => {
        const fetchImages = async () => {
            if (!Array.isArray(docSections)) {
                return;
            }
    
            const imagePromises = docSections.map(async (section) => {
                if (section.featured_media) {
                    try {
                        const media = await wp.apiFetch({ path: `/wp/v2/media/${section.featured_media}` });
                        return { id: section.id, imageUrl: media.source_url };
                    } catch (error) {
                        console.error("Error fetching media:", error);
                        return { id: section.id, imageUrl: null };
                    }
                }
                return { id: section.id, imageUrl: null };
            });
    
            const results = await Promise.all(imagePromises);
            const imageMap = results.reduce((acc, { id, imageUrl }) => {
                acc[id] = imageUrl;
                return acc;
            }, {});
            setImages(imageMap);
        };
    
        const safeDocSections = docSections || [];
        fetchImages(safeDocSections);
    }, [docSections]);
    
    return (
        <div className={`${layoutType}`}>
            {docSections &&
                docSections.map((section) => {
                    const { id, title, featured_media } = section;

                    // Find the child items for the current section
                    const sectionItems = allDocItems.find((item) => item.parentId === id)?.items || [];                    
                    // Get the image URL from state
                    const imageUrl = images[id];
                    
                     return (
                        <div key={id} className="topic_list_item box-item wow fadeIn" data-wow-delay="0.2s">
                            <a href="" className="topic-title">


                                {isFeaturedImage && imageUrl && (
                                    <img src={imageUrl} alt={title.rendered} />
                                )}  
                                
                                <h4 className="ct-heading-text">{title?.rendered}</h4>
                                {show_topic && (
                                    <span className="ezd-badge ezd-circle">{childCounts[section.id]}</span>
                                )}
                            </a>
                            <ul className="ezd-list-unstyled">
                                {sectionItems &&
                                    sectionItems.map((item) => (
                                        <li key={item.id}>
                                            <a className="ct-content-text" href="">
                                                <i className="icon_document_alt"></i>
                                                {item.title?.rendered}
                                            </a>
                                        </li>
                                    ))}
                            </ul>
                            <a href="" className="text_btn dark_btn">
                                {readMoreText} <i className="arrow_right"></i>
                            </a>
                        </div>
                    );
                })}
        </div>
    );
}
